import { date, file, mandatoryString, nullDate } from "@/constants/zodTypes";
import { Perimeter } from "@/lib/perimeter";
import { perimeterSchema } from "@molecules/PerimeterForm/PerimeterFormSchema";
import { z } from "zod";

const certificateSchema = z.object({
  number: mandatoryString(),
  country: mandatoryString(),
  expirationDate: date(
    new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
    new Date(new Date().getTime() + 100 * 365 * 24 * 60 * 60 * 1000),
  ),
  file: file(),
  perimeter: perimeterSchema,
});

const getCertificateDefaultValues = (): z.infer<typeof certificateSchema> => ({
  number: "",
  expirationDate: nullDate(),
  country: "",
  file: new File([""], ""),
  perimeter: Perimeter.empty(),
});

export { getCertificateDefaultValues, certificateSchema };
